import logo from "./logo.svg";
import "./App.css";
import MainNavigation from "./navigation";

function App() {
  return <MainNavigation />;
}

export default App;
